import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./moreDetails.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { generateLocalizedBadge, generateSimpleBadge } from '~/modules/helpers/badgeHelper';
import { selectCompatibleWith, selectRequiredProducts, selectRequiredListings, selectSalesforceEditions } from '~/modules/helpers/compatibilityHelper';
import { Routes } from '~/modules/routes';
import { WireI18n } from '~/modules/stores/i18nStore';
import { listingStore, selectListing } from '~/modules/stores/listingStore';
import { routerStore, selectScrollToQueryParam } from '~/modules/stores/routerStore';
import { scrollToElement } from '~/modules/utilities/browser';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
class MoreDetails extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = void 0;
    this.i18n = void 0;
    this.listingStoreState = void 0;
    this.
    // @ts-expect-error * Automated Type Error Fix
    scrollToParam = void 0;
  }
  renderedCallback() {
    scrollToElement(this, this.scrollToParam);
  }
  get forceListing() {
    return selectExtensionListing(this.listing);
  }
  get additionalDetails() {
    return this.listing?.fullDescription;
  }
  get compatibilityWith() {
    const labels = this.i18n.listingDetails.productsSupported;
    const compatibilityFeatures = selectCompatibleWith(this.forceListing);
    return compatibilityFeatures.map(key => generateSimpleBadge(labels[key] || key));
  }
  get requiredProducts() {
    const labels = this.i18n.listingDetails.productsSupported;
    const requiredProducts = selectRequiredProducts(this.forceListing);
    return requiredProducts.map(key => generateSimpleBadge(labels[key] || key));
  }
  get prerequisiteAppsData() {
    const requiredListingIds = selectRequiredListings(this.forceListing);
    if (!requiredListingIds || requiredListingIds.length === 0) {
      return {
        link: null,
        message: null
      };
    }
    const listingId = requiredListingIds[0];
    const listing = selectListing(this.listingStoreState, listingId);
    if (!listing || !listing.name) {
      return {
        link: null,
        message: null
      };
    }
    if (listing.public === false) {
      return {
        link: null,
        message: this.i18n.listingDetails.partnerProducts.privateAppMessage
      };
    }
    return {
      link: {
        id: listingId,
        name: listing.name,
        url: `/${Routes.LISTING}?listingId=${listingId}`
      },
      message: null
    };
  }
  get salesforceEditions() {
    const salesforceEditions = selectSalesforceEditions(this.forceListing);
    return salesforceEditions.map(key => generateLocalizedBadge(key));
  }
  get additionalRequirements() {
    return this.forceListing?.systemRequirements ?? '';
  }
  get compatibilitySummary() {
    return {
      compatibleWith: this.compatibilityWith,
      requiredProducts: this.requiredProducts,
      prerequisiteAppsData: this.prerequisiteAppsData,
      salesforceEditions: this.salesforceEditions,
      additionalRequirements: this.additionalRequirements
    };
  }
  get moreResources() {
    // @ts-expect-error * Automated Type Error Fix
    return this.listing && this.listing['listing/plugins/Content'];
  }
  get displayMoreResources() {
    return this.moreResources && this.moreResources.length > 0;
  }
  get shouldDisplaySupportInfo() {
    // @ts-expect-error * Automated Type Error Fix
    return this.listing['listing/plugins/SupportInformation'];
  }
  get appDetailsColumnSize() {
    return '1:1@small 2:4@large';
  }
  get additionalDetailsColumnSize() {
    if (this.shouldDisplaySupportInfo) {
      return '1:1@small 2:3@large';
    }
    return '1:1@small 3:3@large';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MoreDetails, {
  publicProps: {
    listing: {
      config: 0
    }
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    },
    listingStoreState: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: listingStore
        };
      }
    },
    scrollToParam: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: routerStore,
          selector: selectScrollToQueryParam
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(MoreDetails, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;